import { useCreateUsageSourceMutation, useEditUsageSourceMutation } from "../../../api/usageSourceApi";

/**
 * Data/API Layer - mirrors _features/billingUnits/modals/
 * BillingUnitFormModal/hooks/useBillingUnitFormMutations.js. Create/edit
 * only - the validate mutation lives in useUsageSourceValidation.js
 * instead, since it's a distinct concern (a pre-submit check, not part of
 * the create/edit write path).
 */
export function useUsageSourceFormMutations() {
  const [createUsageSource, { isLoading: isCreating }] = useCreateUsageSourceMutation();
  const [updateUsageSource, { isLoading: isUpdating }] = useEditUsageSourceMutation();

  async function submitUsageSource({ mode, validData, rowData }) {
    if (mode === "create") {
      return await createUsageSource(validData).unwrap();
    }

    return await updateUsageSource({ ...validData, _id: rowData?._id }).unwrap();
  }

  return {
    submitUsageSource,
    isSubmitting: isCreating || isUpdating,
  };
}
